import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import * as VueMoment from 'vue-moment';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VueCurrencyInput from 'vue-currency-input';
import VueCurrencyFilter from 'vue-currency-filter';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueMoment);
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
});
Vue.component('v-select', vSelect);
Vue.component('v-datepicker', Datepicker);
Vue.use(VueCurrencyInput);

Vue.use(VueCurrencyFilter, {
  symbol : '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: false,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
